import { Component, Input } from '@angular/core';
import { BaseEntity, BaseState, GenericListEntity, Notification } from '@base/entities/BaseEntities';
import { BaseGridComponent } from "@base/component/BaseGridComponent";
import { ServiceBagService, ServiceBagServices } from "@m4u-angular/base/component/ServiceBag";

class State extends BaseState {
    Templates: GenericListEntity[];
}

@Component({
    providers: ServiceBagServices,
    selector: 'app-notificationgrid',
    templateUrl: './notificationgrid.component.html',
    styleUrls: ['./notificationgrid.component.scss']
})
export class NotificationGridComponent extends BaseGridComponent<Notification, State>
{
    @Input() set Templates (value: GenericListEntity[]) {
        this.State.Templates = value;
    }

    constructor(A: ServiceBagService, componentName: string) {
        super(A, componentName, Notification, State);
    }

    override OnInitComponentFinished() {
        super.OnInitComponentFinished();
        if (this.G) this.G.grid.columnHidingEnabled = false;
    }
   
    OnNavigate(e) {
        this.Navigate(["/pages/general/notificationview", e.data.EntryID]);
    }   
}
